/* David Pladen — enlarge product photos (sections/dp-product-zoom.liquid).
 * Click or Enter on a photo in the DP product gallery ([data-dp-slides])
 * opens it full screen. Previous/next buttons, arrow keys and swipe move
 * through the visible photos; clicking the enlarged photo zooms in further
 * and the zoom follows the pointer or finger. Escape or × closes.
 */

(() => {
  if (window.DpZoomLoaded) return;
  window.DpZoomLoaded = true;

  const SLIDE = '[data-dp-slides] .pd-sl:not([hidden]):not(.pd-sl--video)';
  let photos = [];
  let index = 0;
  let trigger = null;
  let touchX = null;

  const box = () => document.querySelector('[data-dpz]');

  // The largest file in the photo's srcset
  const largest = (img) => {
    const set = img.getAttribute('srcset');
    if (!set) return img.currentSrc || img.src;
    return set
      .split(',')
      .map((part) => part.trim().split(/\s+/))
      .sort((a, b) => parseInt(b[1], 10) - parseInt(a[1], 10))[0][0];
  };

  const photoOf = (slide) => slide.querySelector('img:not(.bl)');

  const setZoom = (on, x = 50, y = 50) => {
    const b = box();
    b.classList.toggle('is-zoomed', on);
    b.querySelector('[data-dpz-img]').style.transformOrigin = `${x}% ${y}%`;
  };

  const show = (i) => {
    const b = box();
    index = (i + photos.length) % photos.length;
    const src = photoOf(photos[index]);
    const img = b.querySelector('[data-dpz-img]');
    img.src = largest(src);
    img.alt = src.alt || '';
    setZoom(false);
    const count = b.querySelector('[data-dpz-count]');
    if (count) count.textContent = photos.length > 1 ? `${index + 1} / ${photos.length}` : '';
    b.querySelectorAll('[data-dpz-step]').forEach((button) => {
      button.hidden = photos.length < 2;
    });
  };

  const open = (slide) => {
    const b = box();
    if (!b) return;
    photos = Array.from(document.querySelectorAll(SLIDE)).filter(photoOf);
    const start = photos.indexOf(slide);
    if (start < 0) return;
    trigger = document.activeElement;
    show(start);
    b.hidden = false;
    document.documentElement.classList.add('dp-scroll-lock');
    b.querySelector('[data-dpz-close]').focus();
  };

  const close = () => {
    const b = box();
    if (!b || b.hidden) return;
    b.hidden = true;
    setZoom(false);
    document.documentElement.classList.remove('dp-scroll-lock');
    trigger?.focus?.({ preventScroll: true });
  };

  // Pointer position inside the stage, in percent
  const point = (event, stage) => {
    const r = stage.getBoundingClientRect();
    return [((event.clientX - r.left) / r.width) * 100, ((event.clientY - r.top) / r.height) * 100];
  };

  document.addEventListener('click', (event) => {
    const b = box();
    if (!b) return;

    if (b.hidden) {
      const slide = event.target.closest(SLIDE);
      if (slide && photoOf(slide)) open(slide);
      return;
    }

    if (event.target.closest('[data-dpz-close]')) return close();
    const step = event.target.closest('[data-dpz-step]');
    if (step) return show(index + parseInt(step.dataset.dpzStep, 10));

    const stage = event.target.closest('[data-dpz-stage]');
    if (!stage) return;
    if (event.target.matches('[data-dpz-img]') && b.dataset.zoom === 'true') {
      const [x, y] = point(event, stage);
      setZoom(!b.classList.contains('is-zoomed'), x, y);
    } else if (!event.target.matches('[data-dpz-img]')) {
      close();
    }
  });

  // Zoomed: the zoom follows the pointer
  document.addEventListener('mousemove', (event) => {
    const b = box();
    if (!b || b.hidden || !b.classList.contains('is-zoomed')) return;
    const [x, y] = point(event, b.querySelector('[data-dpz-stage]'));
    b.querySelector('[data-dpz-img]').style.transformOrigin = `${x}% ${y}%`;
  });

  // Touch: swipe for previous/next; when zoomed, the finger moves the zoom
  document.addEventListener('touchstart', (event) => {
    const b = box();
    if (!b || b.hidden || !event.target.closest('[data-dpz-stage]')) return;
    touchX = event.touches[0].clientX;
  }, { passive: true });

  document.addEventListener('touchmove', (event) => {
    const b = box();
    if (!b || b.hidden || !b.classList.contains('is-zoomed')) return;
    const [x, y] = point(event.touches[0], b.querySelector('[data-dpz-stage]'));
    b.querySelector('[data-dpz-img]').style.transformOrigin = `${x}% ${y}%`;
  }, { passive: true });

  document.addEventListener('touchend', (event) => {
    const b = box();
    if (!b || b.hidden || touchX === null || b.classList.contains('is-zoomed')) return;
    const dx = event.changedTouches[0].clientX - touchX;
    touchX = null;
    if (Math.abs(dx) > 50 && photos.length > 1) show(index + (dx < 0 ? 1 : -1));
  });

  document.addEventListener('keydown', (event) => {
    const b = box();
    if (!b) return;
    if (b.hidden) {
      // Enter on the focused gallery opens the photo in view
      const slides = event.target.closest?.('[data-dp-slides]');
      if (!slides || event.target !== slides || (event.key !== 'Enter' && event.key !== ' ')) return;
      const r = slides.getBoundingClientRect();
      const inView = Array.from(document.querySelectorAll(SLIDE)).find((s) => {
        const sr = s.getBoundingClientRect();
        return sr.right > r.left + 4 && sr.left < r.right - 4 && sr.bottom > r.top && sr.top < r.bottom;
      });
      if (inView) {
        event.preventDefault();
        open(inView);
      }
      return;
    }
    if (event.key === 'Escape') close();
    else if (event.key === 'ArrowLeft' && photos.length > 1) show(index - 1);
    else if (event.key === 'ArrowRight' && photos.length > 1) show(index + 1);
    else if (event.key === 'Tab') {
      const items = Array.from(b.querySelectorAll('button:not([hidden])'));
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
})();

/* Colour tiles: one scrolling row with round arrows when it is longer than
   the column (styles in assets/dp-gallery-zoom.css, "Colour tiles"). */
(() => {
  const setup = (row) => {
    if (row.dataset.swr) return;
    row.dataset.swr = '1';
    const wrap = document.createElement('div');
    wrap.className = 'pd-swr';
    row.parentNode.insertBefore(wrap, row);
    wrap.appendChild(row);
    const arrows = [-1, 1].map((dir) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'pd-swr-ar';
      b.dataset.dir = dir;
      b.setAttribute('aria-label', dir < 0 ? 'Previous colours' : 'More colours');
      b.innerHTML = dir < 0
        ? '<svg width="8" height="12" viewBox="0 0 8 12" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><path d="M6.5 1L1.5 6l5 5"/></svg>'
        : '<svg width="8" height="12" viewBox="0 0 8 12" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><path d="M1.5 1l5 5-5 5"/></svg>';
      b.addEventListener('click', () => row.scrollBy({ left: dir * row.clientWidth * 0.8 }));
      wrap.appendChild(b);
      return b;
    });
    const update = () => {
      const max = row.scrollWidth - row.clientWidth;
      arrows[0].hidden = row.scrollLeft < 4;
      arrows[1].hidden = row.scrollLeft >= max - 4;
    };
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    const on = row.querySelector('.is-on');
    if (on && on.offsetLeft + on.offsetWidth > row.clientWidth) row.scrollLeft = on.offsetLeft - 8;
    update();
  };
  const init = (scope = document) => scope.querySelectorAll('.pd-sw').forEach((row) => {
    if (row.querySelector('a.pd-swl')) setup(row);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

/* "In the wild" videos: no autoplay for visitors who prefer reduced motion */
(() => {
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const stop = () => document.querySelectorAll('.pw-im video').forEach((v) => {
    v.pause();
    v.removeAttribute('autoplay');
    v.controls = true;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', stop);
  else stop();
})();